import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useEffect, useState } from "react";
import { DownloadIcon, FileIcon } from "src/components/ui-icons/upload";
import { selectItems } from "src/modules/spItems/selectors";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import moment from "moment";
import { selectUsers } from "src/modules/users/selector";
import {
  documentByCardFilesLibName,
  equipmentsListName,
  myDocumentsListName,
  versionsCardListName,
} from "src/api/config";
import { getItemsRequest } from "src/modules/spItems/api";
import _ from "lodash";

type Props = {
  JsomHistoryFields: string;
  versionView: any;
  documentCardID: any;
};

const HistoryFieldChanges = (props: Props) => {
  const { JsomHistoryFields, documentCardID } = props;
  const [show, setShow] = useState(false);
  const [fieldsChanges, setFieldChanges] = useState<any>({});
  const [versionsDocument, setVersionsDocument] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const [card, setCard] = useState<any>(null);
  const [filesArr, setFilesArr] = useState<any>([]);

  useEffect(() => {
    getItemsRequest({ listName: versionsCardListName, filters: { MainDocument: documentCardID } }).then((results) => {
      setVersionsDocument([...results.items]);
    });
  }, []);

  useEffect(() => {
    if (JsomHistoryFields) {
      const tempHistoryFieldsChanges = JSON.parse(JsomHistoryFields);
      delete tempHistoryFieldsChanges["Code"];
      delete tempHistoryFieldsChanges["Path"];
      setFieldChanges(tempHistoryFieldsChanges);
    }
  }, [JsomHistoryFields]);

  useEffect(() => {
    getItemsRequest({
      listName: myDocumentsListName,
      filters: { ID: documentCardID },
    }).then((results) => {
      setCard(results.items.length > 0 && results.items[0]);
    });
  }, []);

  useEffect(() => {
    if (versionsDocument.length > 0) {
      let versionsIds: number[] = [];
      versionsDocument.map((version: any) => {
        versionsIds = [...versionsIds, version.ID];
      });
      if (versionsIds.length > 0) {
        getItemsRequest({
          listName: documentByCardFilesLibName,
          filters: {
            CardID: versionsIds,
            VersionDocument: true,
          },
          sortOrder: { name: "ID", asc: true },
        }).then((results) => {
          setFilesArr((prevState: any) =>
            _.orderBy([...prevState, ...results.items], "ID", "asc")
          );
        });
      }
    }
  }, [versionsDocument]);

  useEffect(() => {
    if (card) {
      getItemsRequest({
        listName: documentByCardFilesLibName,
        filters: {
          CardID: card.ID,
          VersionDocument: false,
        },
        sortOrder: { name: "ID", asc: true },
      }).then((results) => {
        setFilesArr((prevState: any) =>
          _.orderBy([...prevState, ...results.items], "ID", "asc")
        );
      });
    }
  }, [card]);

  const downLoadHandle = (e: any, url: string, name: string) => {
    e.preventDefault();
    fetch(url, {
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const printFile = new File([blob], name, {
          type: blob.type,
          lastModified: moment().unix(),
        });
        let reader = new FileReader();
        reader.readAsDataURL(printFile);
        reader.onload = function () {
          const src = reader.result;
          const linkDownLoad: HTMLAnchorElement = document.createElement("a");
          linkDownLoad.setAttribute("download", printFile.name);
          // @ts-ignore
          linkDownLoad.setAttribute("href", src);
          linkDownLoad.style.display = "none";
          document.body.appendChild(linkDownLoad);
          linkDownLoad.click();
          document.body.removeChild(linkDownLoad);
        };
      });
  };

  return (
    <div className="w-full">
      {Object.keys(fieldsChanges).length > 0 && (
        <>
          <div
            onClick={() => setShow(!show)}
            className="text-sm flex items-center mb-6 cursor-pointer"
          >
            {(!show && (
              <>
                <ArrowDown />
                &nbsp;&nbsp;<span>Показать изменения</span>
              </>
            )) || (
                <>
                  <ArrowUp />
                  &nbsp;&nbsp;<span>Скрыть изменения</span>
                </>
              )}
          </div>
          {show && (
            <div className="flex gap-5 flex-col">
              {Object.keys(fieldsChanges).map((keyField: string) => (
                <>
                  {keyField === "File" &&
                    fieldsChanges[keyField] &&
                    fieldsChanges[keyField]["old"] &&
                    fieldsChanges[keyField]["old"].length > 0 && (
                      <>
                        {Object.keys(fieldsChanges[keyField]).map(
                          (key: string) => (
                            <>
                              {key === "old" && (
                                <a
                                  onClick={(e) =>
                                    downLoadHandle(
                                      e,
                                      fieldsChanges[keyField]["old"][0][
                                      "FileRef"
                                      ],
                                      fieldsChanges[keyField]["old"][0][
                                      "FileLeafRef"
                                      ]
                                    )
                                  }
                                  href=""
                                  className="flex items-center w-full"
                                >
                                  <span>Документ (старый):</span>&nbsp;
                                  <div className="grow flex items-center py-2 px-4 bg-[#F3F4F6] rounded-lg justify-between">
                                    <div className="flex items-center text-sm text-[#BA0C2F]">
                                      <FileIcon />
                                      &nbsp;
                                      {
                                        fieldsChanges[keyField]["old"][0][
                                        "FileLeafRef"
                                        ]
                                      }
                                    </div>
                                    <DownloadIcon />
                                  </div>
                                </a>
                              )}
                              {key === "new" && filesArr.length > 0 && (
                                <a
                                  onClick={(e) =>
                                    downLoadHandle(
                                      e,
                                      filesArr[
                                      filesArr.findIndex(
                                        (file: any) =>
                                          file.FileRef ===
                                          fieldsChanges[keyField]["old"][0][
                                          "FileRef"
                                          ]
                                      ) + 1
                                      ]["FileRef"],
                                      filesArr[
                                      filesArr.findIndex(
                                        (file: any) =>
                                          file.FileRef ===
                                          fieldsChanges[keyField]["old"][0][
                                          "FileRef"
                                          ]
                                      ) + 1
                                      ]["FileLeafRef"]
                                    )
                                  }
                                  href=""
                                  className="flex items-center w-full"
                                >
                                  <span>Документ (новый):</span>&nbsp;
                                  <div className="grow flex items-center py-2 px-4 bg-[#F3F4F6] rounded-lg justify-between">
                                    <div className="flex items-center text-sm text-[#22AD5C]">
                                      <FileIcon />
                                      &nbsp;
                                      {
                                        filesArr[
                                        filesArr.findIndex(
                                          (file: any) =>
                                            file.FileRef ===
                                            fieldsChanges[keyField]["old"][0][
                                            "FileRef"
                                            ]
                                        ) + 1
                                        ]["FileLeafRef"]
                                      }
                                    </div>
                                    <DownloadIcon />
                                  </div>
                                </a>
                              )}
                            </>
                          )
                        )}
                      </>
                    )}
                  {keyField === "Title" && (
                    <div className="text-sm flex items-center">
                      <span>Название:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]}
                      </span>
                    </div>
                  )}
                  {keyField === "DocType" && (
                    <div className="text-sm flex items-center">
                      <span>Тип документа:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "Collection" && (
                    <div className="text-sm flex items-center">
                      <span>Коллекция:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "Department" && (
                    <div className="text-sm flex items-center">
                      <span>Подразделение/Функция:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "Sector" && (
                    <div className="text-sm flex items-center">
                      <span>Колонна/Направление/Отдел:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "Process" && (
                    <div className="text-sm flex items-center">
                      <span>Блок колонны/Участок:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "WorkPlaces" && (
                    <div className="text-sm flex items-center">
                      <span>Рабочее место:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"] &&
                          Array.isArray(fieldsChanges[keyField]["old"]) &&
                          fieldsChanges[keyField]["old"].length > 0 &&
                          fieldsChanges[keyField]["old"]
                            .map((place) => place.name)
                            .join(",")}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"] &&
                          Array.isArray(fieldsChanges[keyField]["new"]) &&
                          fieldsChanges[keyField]["new"].length > 0 &&
                          fieldsChanges[keyField]["new"]
                            .map((place) => place.name)
                            .join(",")}
                      </span>
                    </div>
                  )}
                  {keyField === "Critical" && (
                    <div className="text-sm flex items-center">
                      <span>Критичность:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {fieldsChanges[keyField]["old"]["name"]}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {fieldsChanges[keyField]["new"]["name"]}
                      </span>
                    </div>
                  )}
                  {keyField === "ResponsibleForRevision" && (
                    <div className="text-sm flex items-center">
                      <span>Ответственный за пересмотр:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        <a
                          href={`mailto:${fieldsChanges[keyField]["old"][0]["value"]}`}
                        >
                          {fieldsChanges[keyField]["old"][0]["label"]}
                        </a>
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        <a
                          href={`mailto:${fieldsChanges[keyField]["new"][0]["value"]}`}
                        >
                          {fieldsChanges[keyField]["new"][0]["label"]}
                        </a>
                      </span>
                    </div>
                  )}
                  {keyField === "ApproverChange" && (
                    <div className="text-sm flex-col flex">
                      <span>Изменена цепочка согласующих:</span>
                      {fieldsChanges[keyField]["old"].map(
                        (oldEmail: string) => (
                          <>
                            <span className="text-[#BA0C2F] line-through">
                              <a href={`mailto:${oldEmail}`}>
                                {users[oldEmail] &&
                                  users[oldEmail]["displayName"]}
                              </a>
                            </span>
                          </>
                        )
                      )}
                      {fieldsChanges[keyField]["new"].map(
                        (newEmail: string) => (
                          <>
                            <span className="text-[#22AD5C]">
                              <a href={`mailto:${newEmail}`}>
                                {users[newEmail] &&
                                  users[newEmail]["displayName"]}
                              </a>
                            </span>
                          </>
                        )
                      )}
                    </div>
                  )}
                  {keyField === "DateForRevision" && (
                    <div className="text-sm flex items-center">
                      <span>Срок пересмотра:&nbsp;</span>
                      <span className="text-[#BA0C2F] line-through">
                        {moment(
                          fieldsChanges[keyField]["old"]["startDate"]
                        ).format("DD.MM.YYYY")}
                      </span>
                      &nbsp;
                      <span className="text-[#22AD5C]">
                        {moment(
                          fieldsChanges[keyField]["new"]["startDate"]
                        ).format("DD.MM.YYYY")}
                      </span>
                    </div>
                  )}
                  {keyField === equipmentsListName && (
                    <>
                      {Object.keys(fieldsChanges[keyField]).map(
                        (key: string) => (
                          <>
                            {key === "old" &&
                              fieldsChanges[keyField] &&
                              fieldsChanges[keyField][key] &&
                              fieldsChanges[keyField][key].length > 0 && (
                                <div className="flex items-start w-full">
                                  <span>Оборудование (старое):</span>&nbsp;
                                  <div className="flex flex-col gap-2">
                                    {fieldsChanges[keyField][key].map(
                                      (item: any) => (
                                        <div className="grow flex items-center py-2 px-4 bg-[#F3F4F6] rounded-lg">
                                          <div className="text-sm text-[#BA0C2F]">
                                            <span>
                                              <strong>
                                                SAP № технического места:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.name}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>Линия розлива:</strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.Line && item.Line.name}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Название оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.Title}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Производитель оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP &&
                                                item.SAP.Manufacturer}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Модель оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.Model}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>Тип оборудования:</strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP &&
                                                item.SAP.TypeEquipment}
                                            </span>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            {key === "new" &&
                              fieldsChanges[keyField] &&
                              fieldsChanges[keyField][key] &&
                              fieldsChanges[keyField][key].length > 0 && (
                                <div className="flex items-start w-full">
                                  <span>Оборудование (новое):</span>&nbsp;
                                  <div className="flex flex-col gap-2">
                                    {fieldsChanges[keyField][key].map(
                                      (item: any) => (
                                        <div className="grow flex items-center py-2 px-4 bg-[#F3F4F6] rounded-lg">
                                          <div className="text-sm text-[#22AD5C]">
                                            <span>
                                              <strong>
                                                SAP № технического места:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.name}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>Линия розлива:</strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.Line && item.Line.name}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Название оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.Title}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Производитель оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP &&
                                                item.SAP.Manufacturer}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>
                                                Модель оборудования:
                                              </strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP && item.SAP.Model}
                                            </span>
                                            <br />
                                            <span>
                                              <strong>Тип оборудования:</strong>
                                              &nbsp;
                                            </span>
                                            <span>
                                              {item.SAP &&
                                                item.SAP.TypeEquipment}
                                            </span>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                          </>
                        )
                      )}
                    </>
                  )}
                </>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HistoryFieldChanges;
